import styled from 'styled-components';

interface FrameContainerProps {
  isActive?: boolean;
  scale?: number;
}

interface LoaderContainerProps {
  isHidden?: boolean;
}

interface StyledImageProps {
  isHidden?: boolean;
}

export const FrameContainer = styled.div.attrs({
  className: 'FrameContainer',
})<FrameContainerProps>(
  ({ isActive, scale }) => `
    // height: 100%;
    // background: black;
    border-radius: 5px;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    flex: 1;
    // min-width: 100%;
    display:${isActive ? 'flex' : 'none'};
    transform: scale(${scale});
  `
);

export const LoaderContainer = styled.div.attrs({
  className: 'LoaderContainer',
})<LoaderContainerProps>(
  ({ isHidden }) => `
    display: ${isHidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  `
);

export const StyledImage = styled.img.attrs({
  className: 'StyledImage',
})<StyledImageProps>(
  ({ isHidden }) => `
    display: ${isHidden ? 'none' : 'block'};
    // transition: transform 0.2s ease-in-out;
    height: 100%;
    // width: 100%:
    // max-width: 100%;
    // max-height: 100%;
    object-fit: contain;
  `
);
